import {createBrowserRouter, Navigate, RouterProvider} from 'react-router-dom';
import {DeviceWrapper, LanguageAndCredentialWrapper} from "@yosmanyga/fortaleza-core";

import {
  DeleteScreen,
  FeedbackScreen,
  HelpScreen,
  MapScreen,
  NotesScreen,
  PaymentScreen,
  PaymentSuccessScreen,
  PlayScreen,
  RestorationScreen,
  WelcomeScreen
} from './screens';

const OnNotAuthenticatedComponent = () => {
    return <Navigate to="/welcome"/>;
}

const router = createBrowserRouter(
    [
        {
            path: '/welcome',
            element: <WelcomeScreen/>,
        },
        {
            path: '/',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <PlayScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/map',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <MapScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/notes',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <NotesScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/feedback',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <FeedbackScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/help',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <HelpScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/restart',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <DeleteScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/restoration',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <RestorationScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/payment',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <PaymentScreen/>
            </LanguageAndCredentialWrapper>,
        },
        {
            path: '/payment-success',
            element: <LanguageAndCredentialWrapper OnNotAuthenticatedComponent={OnNotAuthenticatedComponent}>
                <PaymentSuccessScreen/>
            </LanguageAndCredentialWrapper>,
        },
    ],
    {
        basename: window.location.pathname
    }
);

const AppRouter = () => {
    return <RouterProvider
        router={router}
    />
};

const AppRouterWithDeviceWrapper = () => {
    return <DeviceWrapper>
        <AppRouter/>
    </DeviceWrapper>
}

export {AppRouterWithDeviceWrapper as AppRouter};
